
























































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { SwiperSlide } from 'vue-awesome-swiper'
import ItemDataLive from 'src/assets/ItemDataLive'
import { AttendeeItemData, AttendeeResponseResult } from 'src/assets/AttendeeItemData'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import AttendeesList from 'components/presenter/item/session/manager/AttendeesList.vue'
import SessionChat from 'components/presenter/item/session/manager/SessionChat.vue'
import api from 'src/assets/api/gql'
import Subscription from 'src/assets/api/Subscription'
import SessionGet from 'src/graphql/session/SessionGet.gql'
import SessionUpdate from 'src/graphql/session/SessionUpdate.gql'
import SessionSubscription from 'src/graphql/session/SessionSubscription.gql'
import SessionAttendeesSubscription from 'src/graphql/session/SessionAttendeesSubscription.gql'
import { ItemTypeTopic, Session, SessionAttendee } from 'src/graphql/types'

@Component({
  components: {
    PersonAvatar,
    AttendeesList,
    SessionChat
  }
})
export default class LayoutsPresenterSession extends Vue {
  ItemTypeTopic = ItemTypeTopic
  loading = true
  rightDrawerContent = 'attendees'
  rightDrawerShowing = false
  slides: Json[] = []
  gridSlides: Json[] = []
  session: Session | null = null
  sessionSubscription!: Subscription
  attendees: { [key: string]: SessionAttendee } = {}
  attendeesSubscription!: Subscription

  get currSlideIndex () {
    return this.gridSlides.findIndex(s => ''+s.id === this.session?.data?.showSlideId)
  }

  get currSlide () {
    if (this.currSlideIndex >= 0) {
      return this.gridSlides[ this.currSlideIndex ]
    }
  }

  @Watch('session.topic.data', { deep: true })
  setSlides (topicData: ItemDataLive) {
    this.slides =
      Object.values(topicData?.slides || {})
        .filter(slide => slide.id && !slide.deleted && !slide.hide)
          .sort((a, b) => a.sort - b.sort)
  }

  @Watch('slides')
  gridSlidesSet (slides: Json[]) {
    this.gridSlides =
      slides
        .reduce(
          (result: Json[], slide: Json) => [
            ...result,
            ...(
              slide.meta?.pages
                ? slide.meta.pages
                  .filter((page: Json) => !page.deleted)
                    .map(
                      (page: Json, index: number) =>
                        Object.assign({}, slide, page, {
                          id: `${slide.id}#${page.pageNo}`,
                          meta: { masterSlide: slide, masterSlidePageIndex: index }
                        })
                    )
                : [slide]
            )
          ],
          [] as Json[])
          .sort((a, b) => a.sort - b.sort)
  }

  async created () {
    const { data: { session } } = await api.query({
      query: SessionGet,
      variables: {
        id: +this.$route.params.id
      }
    })
    if (session) {
      session.topic.data = new ItemDataLive(session.topic.id)
      session.data = {}
      session.chatMessages = null
      this.session = session
      this.subscribe()
      this.loading = false
    } else {
      this.$router.replace('/presenter/')
    }
  }

  beforeDestroy () {
    this.session?.topic?.data?.destroy()
    this.sessionSubscription && this.sessionSubscription.end()
    this.attendeesSubscription && this.attendeesSubscription.end()
  }

  subscribe () {
    this.sessionSubscription = new Subscription(SessionSubscription, { sessionId: +this.$route.params.id })
    this.sessionSubscription.start((data: any) => {
      const init = data?.session?.init
      if (init) {
        this.session = Object.assign({}, this.session, init)
      }
      const payload = data?.session?.payload?.data
      if (payload && this.session) {
        if (payload.data) {
          payload.data = this.session.data = Object.assign({}, this.session.data, payload.data)
        }
        Object.assign(this.session, payload as Session)
      }
    })
    this.attendeesSubscription = new Subscription(SessionAttendeesSubscription, { sessionId: +this.$route.params.id })
    this.attendeesSubscription.start((data: any) => {
      const init = data?.sessionAttendees?.init
      if (init) {
        for (const attendee of init) {
          this.attendeeUpdate(attendee)
        }
      }
      const sessionAttendee = data?.sessionAttendees?.sessionAttendee || data?.sessionAttendees?.payload?.data
      if (sessionAttendee) {
        this.attendeeUpdate(sessionAttendee)
      }
    })
  }

  attendeeUpdate (payload: Json) {
    if (this.attendees[ payload.id ]) {
      const data = payload.data
      delete payload.data
      const attendee = Object.assign({}, this.attendees[ payload.id ], payload) as SessionAttendee
      Object.assign(attendee.data, data)
      const responseResult = this.getAttendeeResponseResult(attendee)
      Object.assign(attendee.data, { responseResult })
      this.$set(this.attendees, attendee.id, attendee)
    } else {
      const responseResult = this.getAttendeeResponseResult(payload as SessionAttendee)
      Object.assign(payload.data, { responseResult })
      this.$set(this.attendees, payload.id, payload)
    }
  }

  getAttendeeResponseResult (attendee: SessionAttendee) {
    if (this.session?.topic?.data) {
      const attendeeItemData = new AttendeeItemData(this.session.topic.typeTopic as ItemTypeTopic, this.session.topic.data as ItemDataLive, attendee)
      const attendeeResponseResult = new AttendeeResponseResult(attendeeItemData)
      return attendeeResponseResult
    }
  }

  async save (data: Json) {
    if (this.session) {
      await api.mutate({
        query: SessionUpdate,
        variables: {
          id: this.session.id,
          data: data
        }
      })
    }
  }
}
